// extracted by mini-css-extract-plugin
export default {"editRow":"HistoryReportsList__editRow___AqmhS"};